'use client';

import { useState, useEffect } from 'react';
import { Search01Icon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import LiveSearchList from './LiveSearchList';
import axios from '@/lib/axios';
import { useRouter } from 'next/navigation';
import { pushToDataLayer } from '@/features/gtm/gtmUtils';
import { useAuth } from '@/features/authentication/hooks/auth';

const SearchComponent = () => {
  const { user } = useAuth();

  const router = useRouter();
  const [search, setSearch] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(true);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      const fetchSuggestions = async () => {
        if (search.trim().length > 1 && showSuggestions) {
          try {
            const res = await axios.get(`/api/v2/gigalogy/items/search`, {
              params: { search },
            });
            pushToDataLayer('Search', {
              search_value: search,
              member_id: user?.data?.id,
            });
            setSuggestions(res.data?.data || []);
          } catch (error) {
            console.error('Axios search error:', error);
            setSuggestions([]);
          }
        } else {
          setSuggestions([]);
        }
      };

      fetchSuggestions();
    }, 400);

    return () => clearTimeout(delayDebounce);
  }, [search, showSuggestions]);

  const handleClearSuggestions = () => {
    setSuggestions([]);
    setSearch('');
  };

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    setShowSuggestions(false); // Hide suggestions when searching
    if (search.trim()) {
      router.push(`/shop?search=${search}`);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
    setShowSuggestions(true); // Show suggestions when typing
  };

  return (
    <>
      <div className="search-module position-relative">
        <form onSubmit={handleSearch} className="search-bar d-flex">
          <input
            type="text"
            className="search-bar__input flex-grow-1"
            placeholder="Search for product"
            value={search}
            onChange={handleInputChange}
          />
          <div className="search-bar__search-buttons">
            <button
              className="bg-transparent border-0 shadow-none"
              type="submit" // Make sure it submits the form
            >
              <HugeiconsIcon icon={Search01Icon} />
            </button>
          </div>
        </form>

        {showSuggestions && ( // Only show suggestions when showSuggestions is true
          <LiveSearchList
            suggestions={suggestions}
            clearSuggestions={handleClearSuggestions}
          />
        )}
      </div>
    </>
  );
};

export default SearchComponent;
